/**
 * Menu tĩnh dự phòng khi chưa có menu từ API.
 * Phải đồng bộ với cms-api/configs/menu.py
 */
const homeIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z" fill="currentColor"/></svg>'
const usersIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"/></svg>'
const surveillanceIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 5H19V19H5V5ZM7 17H9V12H7V17ZM11 17H13V7H11V17ZM15 17H17V10H15V17Z"/></svg>'
const settingIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.33 19.42 11.02L21.54 9.37L19.54 5.91L17.04 6.92C16.52 6.52 15.97 6.19 15.35 5.94L14.96 3.29H10.96L10.57 5.94C9.96 6.19 9.39 6.53 8.89 6.92L6.39 5.91L4.39 9.37L6.51 11.02C6.46 11.33 6.42 11.66 6.42 12C6.42 12.34 6.45 12.66 6.5 12.98L4.38 14.63L6.38 18.09L8.88 17.08C9.4 17.48 9.95 17.81 10.57 18.06L10.96 20.71H14.96L15.35 18.06C15.96 17.81 16.53 17.47 17.03 17.08L19.53 18.09L21.53 14.63L19.43 12.98ZM12.96 15.5C11.03 15.5 9.46 13.93 9.46 12C9.46 10.07 11.03 8.5 12.96 8.5C14.89 8.5 16.46 10.07 16.46 12C16.46 13.93 14.89 15.5 12.96 15.5Z"/></svg>'

const menus = [
  {
    title: "Trang Chủ",
    icon: homeIcon,
    permission_required: "",
    tab: [],
    url: "/dashboard",
    code: "HOME_CONTROLLER"
  },
  {
    title: "Quản lý phân quyền",
    icon: usersIcon,
    permission_required: "view_user",
    tab: [
      { title: "Danh sách nhân viên", url: "/list", code: "STAFF_CONTROLLER", permission_required: "view_user" },
      { title: "Nhóm nhân viên", url: "/groups", code: "GROUP_CONTROLLER", permission_required: "view_group" },
      { title: "Phạm vi khoa", url: "/user-scope", code: "STAFF_USER_SCOPE_CONTROLLER", permission_required: "view_user" }
    ],
    url: "/staff/list",
    code: "STAFF_CONTROLLER"
  },
  {
    title: "Giám sát NKBV",
    icon: surveillanceIcon,
    permission_required: "surveillance.patient.view",
    tab: [
      { title: "Bảng điều khiển", url: "/surveillance/dashboard", code: "SURVEILLANCE_DASHBOARD_CONTROLLER", permission_required: "surveillance.report.view" },
      { title: "Công việc của tôi", url: "/surveillance/worklist", code: "SURVEILLANCE_WORKLIST_CONTROLLER", permission_required: "surveillance.patient.view" },
      { title: "Tín hiệu nghi ngờ", url: "/surveillance/signals", code: "SURVEILLANCE_SIGNAL_CONTROLLER", permission_required: "surveillance.signal.view" },
      { title: "Danh sách bệnh nhân", url: "/surveillance/patients", code: "SURVEILLANCE_PATIENT_CONTROLLER", permission_required: "surveillance.patient.view" },
      { title: "Danh sách ca", url: "/surveillance/episodes", code: "SURVEILLANCE_EPISODE_CONTROLLER", permission_required: "surveillance.patient.view" },
      { title: "Case giám sát", url: "/surveillance/cases", code: "SURVEILLANCE_CASE_CONTROLLER", permission_required: "surveillance.case.view" },
      { title: "Báo cáo & mẫu số", url: "/surveillance/reports", code: "SURVEILLANCE_REPORT_CONTROLLER", permission_required: "surveillance.report.view" },
      { title: "Cụm ca", url: "/surveillance/clusters", code: "SURVEILLANCE_CLUSTER_CONTROLLER", permission_required: "surveillance.cluster.view" }
    ],
    url: "/surveillance/episodes",
    code: "SURVEILLANCE_CONTROLLER"
  },
  {
    title: "Cài đặt",
    icon: settingIcon,
    permission_required: "",
    tab: [
      { title: "Cài đặt danh mục", url: "/surveillance/settings", code: "SURVEILLANCE_SETTING_CONTROLLER", permission_required: "surveillance.master.edit" },
      { title: "Cấu hình checklist/tiêu chí", url: "/surveillance/criteria", code: "SURVEILLANCE_CRITERIA_CONTROLLER", permission_required: "surveillance.config.criteria.edit" },
      { title: "Quản trị rule tín hiệu", url: "/surveillance/rules", code: "SURVEILLANCE_RULE_CONTROLLER", permission_required: "surveillance.config.rule.view" },
      { title: "Nhật ký hệ thống", url: "/surveillance/audit", code: "SURVEILLANCE_AUDIT_CONTROLLER", permission_required: "surveillance.audit.view" }
    ],
    url: "/surveillance/settings",
    code: "SETTING_CONTROLLER"
  }
]

export default menus
